var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"navbar",class:[
    { 'navbar--space': _vm.hasMainMenuOpen },
    { 'navbar--border': _vm.navbarActions } ]},[(_vm.navbarActions)?_c('Actions'):_vm._e(),(_vm.menuVisible)?_c('NavigationDrawer'):_vm._e(),(_vm.menuVisible)?_c('Brand'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }